import { render, staticRenderFns } from "./ModalUploadRateDetail.vue?vue&type=template&id=4d023dec&scoped=true&"
import script from "./ModalUploadRateDetail.vue?vue&type=script&lang=js&"
export * from "./ModalUploadRateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploadRateDetail.vue?vue&type=style&index=0&id=4d023dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d023dec",
  null
  
)

export default component.exports